import { render, staticRenderFns } from "./LeaveRequest.vue?vue&type=template&id=0df8e818&"
import script from "./LeaveRequest.vue?vue&type=script&lang=js&"
export * from "./LeaveRequest.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRequest.vue?vue&type=style&index=0&id=0df8e818&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports